import type { Role } from '../models/auth.model';

/**
 * Where a given role lands after login / at the `''` root redirect.
 * Single source of truth — was previously duplicated across `app.routes.ts`,
 * `public.guard.ts`, and `login.page.ts`.
 */
export function landingPathFor(role: Role | null): string {
  switch (role) {
    case 'ADMIN':
      return '/admin/search';
    case 'SUPER_ADMIN':
      return '/admin/provision';
    case 'DESIGNER':
      return '/designer/dashboard';
    case 'JUDGE':
    default:
      return '/judgement';
  }
}

/**
 * Where the `/tracking/:token` dispatch route (the path the printed QR code
 * encodes) sends a given role for a specific Submission's tracking token.
 * `null` means the role has no logistics reason to land on a tracking
 * dashboard at all (see idea_doc.md Step 3, Access Control Guard) — the
 * caller should send them to `/forbidden` instead.
 */
export function trackingPathFor(role: Role | null, token: string): unknown[] | null {
  switch (role) {
    case 'ADMIN':
    case 'SUPER_ADMIN':
      return ['/admin/tracking', token];
    case 'DESIGNER':
      return ['/designer/tracking', token];
    case 'JUDGE':
    default:
      return null;
  }
}
